export default __webpack_public_path__ + "static/media/favicon.9fb4dab9.ico";